import { Validator as FormValidator } from "../form/Validator";
import { scrollToTop } from "../../dom/smoothScroll";

class ContactFormValidator extends FormValidator {
	onSuccess() {
		super.onSuccess();
		scrollToTop(document.querySelector("body"));
	}
}
customElements.define("esc-contact-form-validator", ContactFormValidator);
